import React from 'react';
import PropTypes from 'prop-types';

function THead({ headerData, actions }) {
  return (
    <thead>
      <tr className="AdminTableTHead">
        {
          headerData && headerData.map(column => (
            <th key={column.name} className="AdminTableTHead__th">
              {column.label}
            </th>
          ))
        }
        {
          actions && actions.map(action => (
            <th
              key={action.name}
              className="AdminTableTHead__th AdminTableTHead__th--edit"
            >
              {action.label}
            </th>
          ))
        }
      </tr>
    </thead>
  );
}

THead.propTypes = {
  headerData: PropTypes.array,
  onSelectAllRows: PropTypes.func,
};

export default THead;
